/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Attachment } from '../models/attachment';
import { AttachmentUrl } from '../models/attachment-url';
import { deleteAttachment } from '../fn/attachments/delete-attachment';
import { DeleteAttachment$Params } from '../fn/attachments/delete-attachment';
import { getAttachmentUrl } from '../fn/attachments/get-attachment-url';
import { GetAttachmentUrl$Params } from '../fn/attachments/get-attachment-url';
import { list } from '../fn/attachments/list';
import { List$Params } from '../fn/attachments/list';
import { uploadAttachments } from '../fn/attachments/upload-attachments';
import { UploadAttachments$Params } from '../fn/attachments/upload-attachments';

@Injectable({ providedIn: 'root' })
export class AttachmentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `attachmentsControllerList()` */
  static readonly AttachmentsControllerListPath = '/attachments/{entityClass}/{entityId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `list()` instead.
   *
   * This method doesn't expect any request body.
   */
  list$Response(params: List$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Attachment>>> {
    return list(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `list$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  list(params: List$Params, context?: HttpContext): Observable<Array<Attachment>> {
    return this.list$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Attachment>>): Array<Attachment> => r.body)
    );
  }

  /** Path part for operation `attachmentsControllerUploadAttachments()` */
  static readonly AttachmentsControllerUploadAttachmentsPath = '/attachments/{entityClass}/{entityId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadAttachments()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadAttachments$Response(
    params: UploadAttachments$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<Attachment>>> {
    return uploadAttachments(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadAttachments$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadAttachments(params: UploadAttachments$Params, context?: HttpContext): Observable<Array<Attachment>> {
    return this.uploadAttachments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Attachment>>): Array<Attachment> => r.body)
    );
  }

  /** Path part for operation `attachmentsControllerGetAttachmentUrl()` */
  static readonly AttachmentsControllerGetAttachmentUrlPath = '/attachments/{entityClass}/{entityId}/{attachmentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAttachmentUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttachmentUrl$Response(
    params: GetAttachmentUrl$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<AttachmentUrl>> {
    return getAttachmentUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAttachmentUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttachmentUrl(params: GetAttachmentUrl$Params, context?: HttpContext): Observable<AttachmentUrl> {
    return this.getAttachmentUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<AttachmentUrl>): AttachmentUrl => r.body)
    );
  }

  /** Path part for operation `attachmentsControllerDeleteAttachment()` */
  static readonly AttachmentsControllerDeleteAttachmentPath = '/attachments/{entityClass}/{entityId}/{attachmentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAttachment()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAttachment$Response(
    params: DeleteAttachment$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return deleteAttachment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAttachment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAttachment(params: DeleteAttachment$Params, context?: HttpContext): Observable<void> {
    return this.deleteAttachment$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
